import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import { BoosterEnrollmentPoint } from 'Modules'
import { Bar } from 'react-chartjs-2'

import dayjs from 'libs/dayjs'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface BoosterEnrollmentChartProps {
  data?: BoosterEnrollmentPoint[]
}

const BoosterEnrollmentChart = ({ data = [] }: BoosterEnrollmentChartProps) => {
  const chartData = {
    labels: data.map((point) => dayjs(point.date).format('DD/MM')),
    datasets: [
      {
        label: 'New enrollments',
        data: data.map((point) => point.count),
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        borderWidth: 1,
      },
    ],
  }

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (items: any[]) => {
            const point = data[items[0]?.dataIndex]
            return point ? dayjs(point.date).format('DD/MM/YYYY') : ''
          },
          label: (item: any) => ` ${new Intl.NumberFormat('en-US').format(item.parsed.y)} users`,
        },
      },
    },
    scales: {
      y: { beginAtZero: true, ticks: { precision: 0 } },
    },
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default BoosterEnrollmentChart
